// Zip on-site messaging is only available in AU and NZ.
const ZIP_REGION_BY_SITE_ID = Object.freeze({
  'kl-au': 'au',
  'kl-nz': 'nz',
});

// Afterpay is not available in MY and SG.
const AFTERPAY_LOCALE_BY_CURRENCY = Object.freeze({
  AUD: 'en_AU',
  NZD: 'en_NZ',
  USD: 'en_US',
  GBP: 'en_GB',
  CAD: 'en_CA',
});

const CURRENCY_SYMBOLS = Object.freeze({
  GBP: '£',
  MYR: 'RM',
});

const isValidAmount = (amount) =>
  typeof amount === 'number' && Number.isFinite(amount) && amount > 0;

export const formatAfterpayAmount = (amount) => {
  if (!isValidAmount(amount)) return null;

  return Number.isInteger(amount) ? String(amount) : amount.toFixed(2);
};

export const formatZipPrice = (amount) => {
  if (!isValidAmount(amount)) return null;

  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(amount);
};

export const getAfterpayLocale = (currency, localeId) => {
  if (localeId && typeof localeId === 'string') {
    const normalized = localeId.replace('-', '_');

    if (/^[a-z]{2}_[A-Z]{2}$/.test(normalized)) {
      return normalized;
    }
  }

  return AFTERPAY_LOCALE_BY_CURRENCY[currency] || 'en_AU';
};

export const getZipRegion = (siteId) => ZIP_REGION_BY_SITE_ID[siteId] || null;

export const getCurrencySymbol = (currency) => CURRENCY_SYMBOLS[currency] || '$';

/** SFCC enum-of-string prefs sync as { value, displayValue } via MRT CLIENT_DATA. */
export const normalizeSitePreferenceEnum = (prefValue) => {
  if (prefValue == null || prefValue === '') {
    return null;
  }

  if (typeof prefValue === 'object' && prefValue.value != null) {
    return String(prefValue.value);
  }

  return String(prefValue);
};
